// extracted by mini-css-extract-plugin
export default {"tab":"FooterButton_tab__gLvzQ","default-button-icon":"FooterButton_default-button-icon__8d0cm","label":"FooterButton_label__BLFup","active":"FooterButton_active__UkPUN"};